<!--
 * @Description: 大屏登录弹窗（密码登录，登录成功后写入 dashboardToken）
-->
<template>
  <transition name="login-fade">
    <div v-show="visible" class="dashboard-login-mask" @click.self="handleClose">
      <div class="login-box">
        <span class="login-close" @click="handleClose">&times;</span>
        <input
          v-model.trim="password"
          class="login-input"
          type="password"
          placeholder="请输入密码"
          @keyup.enter="handleLogin"
        />
        <div class="login-error">{{ errorMsg }}</div>
        <button class="login-btn" :disabled="loading" @click="handleLogin">
          {{ loading ? '登录中...' : '登 录' }}
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import { dashboardLogin, dashboardCheckToken } from '@/api/dashboard'
import { getDashboardToken, setDashboardToken } from '@/utils/dashboard-auth'
import to from '@/utils/await-to'
export default {
  name: 'DashboardLoginDialog',
  data() {
    return {
      visible: false,
      password: '',
      errorMsg: '',
      loading: false,
      // 点击弹窗触发的登录，登录成功后继续 resolve
      pendingResolve: null,
    }
  },
  methods: {
    show() {
      this.visible = true
      this.password = ''
      this.errorMsg = ''
    },
    hide() {
      this.visible = false
    },
    // 确保登录有效：无 token/token 失效时弹登录，登录成功后 resolve(true)
    ensure() {
      return new Promise(resolve => {
        const token = getDashboardToken()
        if (token) {
          to(dashboardCheckToken({ dashboardToken: token })).then(([, err]) => {
            if (!err || ~~err.code !== 987989) {
              resolve(true)
              return
            }
            this.pendingResolve = resolve
            this.show()
          })
        } else {
          this.pendingResolve = resolve
          this.show()
        }
      })
    },
    // 关闭弹窗，中断等待
    handleClose() {
      this.hide()
      if (this.pendingResolve) {
        this.pendingResolve(false)
        this.pendingResolve = null
      }
    },
    async handleLogin() {
      if (this.loading) return
      if (!this.password) {
        this.errorMsg = '请输入登录密码'
        return
      }
      this.loading = true
      this.errorMsg = ''
      const [res, err] = await to(dashboardLogin({ password: this.password }))
      this.loading = false
      if (err) {
        this.errorMsg = err.msg || '登录失败，请重试'
        return
      }
      setDashboardToken(res.data.dashboardToken)
      this.hide()
      const resolve = this.pendingResolve
      this.pendingResolve = null
      if (resolve) {
        // 点击弹窗触发的登录，登录后继续打开目标弹窗
        resolve(true)
      } else {
        // 运行中 token 失效触发的登录，刷新页面重新拉取数据
        location.reload()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-login-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(3, 10, 46, 0.85);
  backdrop-filter: blur(6px);

  .login-box {
    position: relative;
    width: 420px;
    box-sizing: border-box;
    padding: 48px 48px 40px;
    border-radius: 12px;
    border: 1px solid rgba(0, 145, 255, 0.55);
    background: linear-gradient(180deg, #0a1e6e 0%, #071447 100%);
    box-shadow: 0 0 40px rgba(0, 107, 252, 0.45);

    .login-close {
      position: absolute;
      right: 16px;
      top: 10px;
      font-size: 28px;
      line-height: 1;
      color: rgba(255, 255, 255, 0.5);
      cursor: pointer;

      &:hover {
        color: #fff;
      }
    }

    .login-input {
      width: 100%;
      height: 48px;
      box-sizing: border-box;
      padding: 0 16px;
      font-size: 18px;
      color: #fff;
      background: rgba(0, 40, 120, 0.5);
      border: 1px solid rgba(0, 145, 255, 0.6);
      border-radius: 6px;
      outline: none;

      &::placeholder {
        color: rgba(255, 255, 255, 0.35);
      }

      &:focus {
        border-color: #33ccff;
        box-shadow: 0 0 8px rgba(51, 204, 255, 0.5);
      }
    }

    .login-error {
      height: 24px;
      margin-top: 10px;
      font-size: 14px;
      color: #ff6b6b;
      text-align: left;
    }

    .login-btn {
      margin-top: 10px;
      width: 100%;
      height: 48px;
      font-size: 18px;
      letter-spacing: 8px;
      color: #fff;
      cursor: pointer;
      border: none;
      border-radius: 6px;
      background: linear-gradient(90deg, #0065fc 0%, #00a2ff 100%);

      &:hover {
        opacity: 0.9;
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
  }
}

.login-fade-enter-active,
.login-fade-leave-active {
  transition: opacity 0.3s;
}

.login-fade-enter,
.login-fade-leave-to {
  opacity: 0;
}
</style>
